import { Coffee } from 'lucide-react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="no-print" style={{ borderTop: '4px solid #ff00ea', background: '#18181b', marginTop: 'auto' }}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <Coffee size={16} className="animate-float" style={{ color: '#ff00ea' }} />
            <span className="font-heading" style={{ fontSize: '0.45rem', color: 'rgba(255,255,255,0.5)' }}>
              COFFEE REWARDS
            </span>
          </div>

          {/* Legal */}
          <div className="flex items-center gap-3">
            <Link to="/privacy" className="font-body" style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.6rem' }}>
              PRIVACY POLICY
            </Link>
            <span style={{ color: 'rgba(255,0,234,0.3)' }}>│</span>
            <Link to="/terms" className="font-body" style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.6rem' }}>
              TERMS OF SERVICE
            </Link>
          </div>

          {/* Tech stack */}
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5">
              <span className="inline-block w-2 h-2 rounded-full animate-heartbeat" style={{ background: '#3dba4c', boxShadow: '0 0 6px #3dba4c' }} />
              <span className="font-body font-bold" style={{ color: '#3dba4c', fontSize: '0.6rem' }}>ONLINE</span>
            </div>
            <span style={{ color: 'rgba(255,0,234,0.3)' }}>│</span>
            <span className="font-body" style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.6rem' }}>
              BIT BREW
            </span>
          </div>

          {/* Copyright */}
          <p className="font-body" style={{ color: 'rgba(255,255,255,0.2)', fontSize: '0.6rem' }}>
            © {new Date().getFullYear()} BUILT WITH{' '}
            <span className="inline-block animate-heartbeat" style={{ color: '#e52222' }}>❤️</span>
            {' '}+{' '}
            <span style={{ color: '#ff00ea' }}>☕</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
